// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__oAnKf","box":"style_box__jk98P","active":"style_active__7GH9u","title":"style_title__8dqHg","item":"style_item__EQNeU"};